"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  eventFilter: {
    blacklisted: []
  },
  defaultRelevantFields: {
    'app.interaction': ['app_interactions:elementname', 'app_interactions:elementtype', 'app_interactions:elementplacement', 'app_interactions:elementid'],
    'app.interaction.nc': ['app_interactions:elementname', 'app_interactions:elementtype', 'app_interactions:elementplacement', 'app_interactions:elementid'],
    newview: ['we_sdk:newviewcount'],
    completedview: ['we_sdk:newviewcount'],
    'blocks.blockstart': ['de:appblocktype', 'de:blockid'],
    'recommendation.display': ['recommendation_display:itemids'],
    'pixelmon.pixel': ['pixelmon_pixel:name'],
    'we-sdk.init': ['we_sdk:projectid', 'sharedidentifiers:pageviewid', 'sharedidentifiers:userid'],
    'walmart.linkout': ['walmart_linkout:url', 'walmart_linkout:walmartids', 'walmart_linkout:type']
  }
};
exports["default"] = _default;